
import styled from "styled-components"
import {BsCheck2} from "react-icons/bs"
import {IoIosClose} from "react-icons/io"
import { useState } from "react"

const Container = styled.div`
    width: 60px;
    height: 28px;
    border-radius:35px;
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;

    animation: ${({status}) => !status && "bgColor .2s linear forwards"};
    animation: ${({status}) => status && "bgColorReverse .2s linear forwards"};

    .top{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: ${({status}) => status ? `translateX(30px)`: `translateX(0)`};
        animation: ${({status, isChanged}) => (status && isChanged) && "toggle .2s linear forwards"};
        animation: ${({status, isChanged}) => (!status && isChanged) &&"toggleReverse .2s linear forwards"};

        .icon{
            font-size: 1.8rem;
            fill: ${({status, isChanged}) => (!isChanged && status) ? "#70f049":(!isChanged && !status) && "#FF0000"};
            animation: ${({status, isChanged}) => (!status && isChanged) && "color .2s linear forwards"};
            animation: ${({status, isChanged}) => (status && isChanged) && "colorReverse .2s linear forwards"};
        }

        .icon-s{
            font-size: 3rem;
            fill: ${({status, isChanged}) => (!isChanged && status) ? "#70f049":(!isChanged && !status) && "#FF0000"};
            animation: ${({status, isChanged}) => (!status && isChanged) && "color .2s linear forwards"};
            animation: ${({status, isChanged}) => (status && isChanged) && "colorReverse .2s linear forwards"};
        }
    }



    @keyframes bgColor {
        0% {
            background-color: #70f049;
        }
        10% {
            background-color: #70F50F;
        }
        20% {
            background-color: #97F113;
        }
        30% {
            background-color: #F2E91F;
        }
        40% {
            background-color: #FCD81E;
        }
        50% {
            background-color: #FDA817;
        }
        60% {
            background-color: #FD7A10;
        }

        70% {
            background-color: #FE4E0B;
        }
        80% {
            background-color: #FE470A;
        }
        90% {
            background-color: #FF0000;
        }

        100% {
            background-color: #FF0000;
        }
    }

    @keyframes bgColorReverse {
        0% {
            background-color: #FF0000;
        }
        
        10% {
            background-color: #FF0000;
        }

        20% {
            background-color: #FE470A;
        }

        30% {
            background-color: #FE4E0B;
        }

        40% {
            background-color: #FD7A10;
        }

        50% {
            background-color: #FDA817;
        }
        60% {
            background-color: #FCD81E;
        }

        70% {
            background-color: #F2E91F;
        }

        80% {
            background-color: #97F113;
        }
        90% {
            background-color: #70F50F;
        }
        
        100% {
            background-color: #70f049;
        }
    }

    @keyframes color {
        0% {
            color: #70f049;
        }
        10% {
            color: #70F50F;
        }
        20% {
            color: #97F113;
        }
        30% {
            color: #F2E91F;
        }
        40% {
            color: #FCD81E;
        }
        50% {
            color: #FDA817;
        }
        60% {
            color: #FD7A10;
        }

        70% {
            color: #FE4E0B;
        }
        80% {
            color: #FE470A;
        }
        90% {
            color: #FF0000;
        }

        100% {
            color: #FF0000;
        }
    }

    @keyframes colorReverse {
        0% {
            color: #FF0000;
        }
        
        10% {
            color: #FF0000;
        }

        20% {
            color: #FE470A;
        }

        30% {
            color: #FE4E0B;
        }

        40% {
            color: #FD7A10;
        }

        50% {
            color: #FDA817;
        }
        60% {
            color: #FCD81E;
        }

        70% {
            color: #F2E91F;
        }

        80% {
            color: #97F113;
        }
        90% {
            color: #70F50F;
        }
        
        100% {
            color: #70f049;
        }
    }

    @keyframes toggle {
        0% {
            transform: translateX(0) rotate(0);
        }


        100% {
            transform: translateX(30px) rotate(360deg);
        }
    }

    @keyframes toggleReverse {
        0% {
            transform: translateX(30px) rotate(360deg);
        }
        100% {
            transform: translateX(0) rotate(0);
        }
    }
`


const AnimatedToggle = ({initial, setState}) => {

    const [status, setStatus] = useState(initial)

    const [isChanged, setIsChanged] = useState()


    const handleClick = () => {
        setStatus((prev) => !prev)
        setState((prev) => !prev)

        //! bu tamamen toggle animasyonu ile alakalı 
        setIsChanged(true)
    }


    //! #70f049
    //! #70F50F
    //! #97F113
    //! #F2E91F
    //! #FCD81E
    //! #FDA817
    //! #FD7A10
    //! #FE4E0B
    //! #FE470A
    //! #FF0000


  return (
    <Container status={status} isChanged={isChanged} onClick={() => handleClick()}>
        <div className="top" >
            {
                status ? 
                <BsCheck2 className="icon"/>:
                <IoIosClose className="icon-s"/>
            }
        </div>
    </Container>
  )
}

export default AnimatedToggle